import {
  Clock, FileText, Upload, CheckCircle, PlayCircle, Car,
  RotateCcw, XCircle, Send
} from "lucide-react";

export const BOOKING_STATUSES = [
  "inquiry", "quote_sent", "docs_payment_pending", "confirmed", "ready",
  "pickup_in_progress", "active", "return_in_progress", "completed", "cancelled",
] as const;

export type BookingStatus = (typeof BOOKING_STATUSES)[number];

export interface BookingStatusConfig {
  label: string;
  color: string;
  bgColor: string;
  barColor: string;
  icon: React.ElementType;
}

export const bookingStatusConfig: Record<BookingStatus, BookingStatusConfig> = {
  inquiry: { label: "Inquiry", color: "text-gray-600", bgColor: "bg-gray-50", barColor: "bg-gray-500", icon: Clock },
  quote_sent: { label: "Quote Sent", color: "text-purple-600", bgColor: "bg-purple-50", barColor: "bg-purple-500", icon: FileText },
  docs_payment_pending: { label: "Docs & Payment", color: "text-orange-600", bgColor: "bg-orange-50", barColor: "bg-orange-500", icon: Upload },
  confirmed: { label: "Confirmed", color: "text-blue-600", bgColor: "bg-blue-50", barColor: "bg-blue-500", icon: CheckCircle },
  ready: { label: "Ready", color: "text-teal-600", bgColor: "bg-teal-50", barColor: "bg-teal-500", icon: CheckCircle },
  pickup_in_progress: { label: "Pickup", color: "text-indigo-600", bgColor: "bg-indigo-50", barColor: "bg-indigo-500", icon: PlayCircle },
  active: { label: "Active", color: "text-emerald-600", bgColor: "bg-emerald-50", barColor: "bg-emerald-500", icon: Car },
  return_in_progress: { label: "Return", color: "text-amber-600", bgColor: "bg-amber-50", barColor: "bg-amber-500", icon: RotateCcw },
  completed: { label: "Completed", color: "text-gray-600", bgColor: "bg-gray-50", barColor: "bg-gray-500", icon: CheckCircle },
  cancelled: { label: "Cancelled", color: "text-red-600", bgColor: "bg-red-50", barColor: "bg-red-500", icon: XCircle },
};

export const ALLOWED_TRANSITIONS: Record<BookingStatus, BookingStatus[]> = {
  inquiry: ["quote_sent", "cancelled"],
  quote_sent: ["docs_payment_pending", "cancelled"],
  docs_payment_pending: ["confirmed", "cancelled"],
  confirmed: ["ready", "cancelled"],
  ready: ["pickup_in_progress", "cancelled"],
  pickup_in_progress: ["active", "ready", "cancelled"],
  active: ["return_in_progress"],
  return_in_progress: ["completed"],
  completed: [],
  cancelled: [],
};

export const VEHICLE_BLOCKING_STATUSES: BookingStatus[] = [
  "ready", "pickup_in_progress", "active", "return_in_progress",
];

export const CANCELLABLE_STATUSES: BookingStatus[] = [
  "inquiry", "quote_sent", "docs_payment_pending", "confirmed", "ready",
];

export function getNextAction(status: BookingStatus) {
  switch (status) {
    case "inquiry": return { label: "Send Quote", icon: Send };
    case "quote_sent": return { label: "Awaiting Docs", icon: FileText };
    case "docs_payment_pending": return { label: "Confirm", icon: CheckCircle };
    case "confirmed": return { label: "Mark Ready", icon: CheckCircle };
    case "ready": return { label: "Start Pickup", icon: PlayCircle, navigate: true };
    case "pickup_in_progress": return { label: "Continue Pickup", icon: PlayCircle, navigate: true };
    case "active": return { label: "Start Return", icon: RotateCcw, navigate: true };
    case "return_in_progress": return { label: "Continue Return", icon: RotateCcw, navigate: true };
    default: return null;
  }
}
